import { fetchApiData, updateApiData, getVvLink, clearVvLink } from "../../../utils/utils";

export const registerUser = async (appInfo, values) => {
  const api = "account/register";
  const gid=localStorage.getItem("gid"); 
  const vvLink = getVvLink();

  const data = {
          first_name: values?.firstName,
          last_name: values?.lastName,
          dob :  values?.dob,
          user_email: values?.email,
          password: values?.password,
          gender : values?.gender,
          referral_code:values?.referralCode,
          guest_user_id:gid
        };
        
  if (vvLink) {
    data.vv_link = vvLink;
  }
  
        const location = {
          path:"common",
          values:data
      }
  
  const response = await updateApiData(appInfo, api, location);
  
  if (response && vvLink) {
    clearVvLink();
  }
  
  return response;
};
export const verifyEmail = async (appInfo, value, userRegisterId) => {
  const api = "account/otp/verify";
  const params = {
    otp:value
  }
  return await fetchApiData(appInfo, api, params, userRegisterId);
};